module.exports = __webpack_public_path__ + "img/jablko.897d65d2.jpg";